module.exports = __webpack_public_path__ + "static/media/logo.e48f9910.png";